import React, { createContext, useContext, useState, useEffect } from "react";
import api from "../config/axios";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const verifyToken = async () => {
      if (token) {
        try {
          // Vérifier si le token est valide en faisant une requête à l'API
          await api.get("/api/verify-token");
          localStorage.setItem("token", token);
          setIsAuthenticated(true);
          api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        } catch (error) {
          console.error("Token invalide:", error);
          localStorage.removeItem("token");
          setIsAuthenticated(false);
          delete api.defaults.headers.common["Authorization"];
        }
      } else {
        localStorage.removeItem("token");
        setIsAuthenticated(false);
        delete api.defaults.headers.common["Authorization"];
      }
      setIsLoading(false);
    };

    verifyToken();
  }, [token]);

  const login = async (username, password) => {
    try {
      console.log("🔄 Tentative de connexion pour l'utilisateur:", username);
      const response = await api.post("/api/login", {
        username,
        password,
      });
      console.log("✅ Connexion réussie, token reçu");
      const newToken = response.data.token;
      localStorage.setItem("token", newToken);
      api.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;
      setToken(newToken);
      setIsAuthenticated(true);
      return true;
    } catch (error) {
      console.error(
        "❌ Erreur de connexion:",
        error.response?.data?.message || error.message
      );
      return false;
    }
  };

  const logout = () => {
    setToken(null);
    setIsAuthenticated(false);
  };

  if (isLoading) {
    return <div>Chargement...</div>;
  }

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
